export const parseId = (id: string | undefined): number | null => {
  return id ? parseInt(id, 10) : null;
};
